class BadRequestError extends Error {
  constructor(message, errors) {
    super(message);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, BadRequestError);
    }

    this.isBadRequestError = true;
    this.errors = errors;
  }
}

export default (message, errors) => new BadRequestError(message, errors);
